import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import Link from 'components/common/Link';
import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';

import { deleteReportStructure } from 'redux/modules/reportStructures';

import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';
import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';

const styles = theme => ({
  root: {
    borderTop: 5,
    borderBottom: 5,
    maxWidth: 'none',
    '& + $root': {
      borderTop: `1px solid ${theme.palette.primary.A100}`,
    },
  },
  gridItemShrink: {
    flexShrink: 1,
  },
  linkRemove: {
    paddingTop: 10,
    paddingBottom: 10,
    marginTop: -10,
    marginBottom: -10,
  },
  listItemSecondaryAction: {
    position: 'static',
    margin: 0,
    transform: 'none',
  },
  typographyName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

class ReportsCreateEditStructuresItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteButtonClick = this.onDeleteButtonClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onDeleteButtonClick(event) {
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { actions, ID } = this.props;
    this.setState({ anchorEl: null });
    actions.deleteReportStructure({ ID });
  }

  render() {
    const {
      ID,
      account,
      classes,
      Name,
      business,
      onClick,
      ...otherProps
    } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <MenuItem
        className={classes.root}
        {...open ? { disableRipple: true } : { onClick: () => {
          onClick();
        } }}
      >
        <div>
          <Grid
            container
            spacing={24}
            alignItems="center"
            wrap="nowrap"
          >
            <Grid
              className={classes.gridItemShrink}
              item
              xs={7}
            >
              <Typography className={classes.typographyName} align="left">
                {Name}
              </Typography>
            </Grid>
            <Grid item>
              <Typography color="secondary">
                {formatUtcToLocalDate(
                  otherProps['Create At'],
                  timeDateFormat,
                  dateFormat,
                  business['Company Address']['Time Zone'],
                  business['Company Address']['Observes Daylight Saving'])}
              </Typography>
            </Grid>
            <Grid
              item
            >
              <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
                <Link
                  className={classes.linkRemove}
                  color="primary"
                  bold
                  size="sm"
                  aria-label="Remove"
                  aria-owns={open ? `${ID}-reports-structure-remove-menu` : null}
                  aria-haspopup="true"
                  onClick={this.onDeleteButtonClick}
                  onMouseDown={(event) => {
                    event.stopPropagation();
                  }}
                  onMouseUp={(event) => {
                    event.stopPropagation();
                  }}
                  disabled={account.Roles.filter(item =>
                    item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
                >
                  Remove
                </Link>
              </ListItemSecondaryAction>
              <Menu
                id={`${ID}-reports-structure-remove-menu`}
                anchorEl={anchorEl}
                open={open}
                onClose={this.onMenuClose}
                list={false}
              >
                <DeleteMenu
                  text="Are you sure you want to delete this columns template?"
                  onCancel={this.onDeleteCancel}
                  onSubmit={this.onDeleteSubmit}
                />
              </Menu>
            </Grid>
          </Grid>
        </div>
      </MenuItem>
    );
  }
}

ReportsCreateEditStructuresItem.propTypes = {
  ID: PropTypes.number.isRequired,
  Name: PropTypes.string.isRequired,
  'Create At': PropTypes.string.isRequired,
  onClick: PropTypes.func,
  actions: PropTypes.shape({
    deleteReportStructure: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    gridItemShrink: PropTypes.string.isRequired,
    linkRemove: PropTypes.string.isRequired,
    listItemSecondaryAction: PropTypes.string.isRequired,
  }).isRequired,
};

ReportsCreateEditStructuresItem.defaultProps = {
  onClick: null,
  business: {},
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteReportStructure }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ReportsCreateEditStructuresItem),
);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsCreateEditForm/ReportsCreateEditStructuresItem.js